import { Fragment } from 'react';

const Footer = () => {
    return (
        <Fragment>
            <footer id="footer" className="footer position-relative dark-background">
                <div className="footer-top">
                    <div className="container">
                        <div className="row gy-4">
                            <div className="col-lg-4 col-md-6 footer-about">
                                <a href="/" className="logo d-flex align-items-center">
                                    <img src="assets/images/logo-blanco.png" alt="" />
                                </a>
                                <div className="footer-contact pt-3">
                                    <p>Montes Himalaya #406</p>
                                    <p>Bosques del Prado, Aguascalientes</p>
                                    <p className="mt-3"><strong>Teléfono:</strong> <span>449 580 0092</span></p>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-3 footer-links">
                                <ul>
                                    <li><a href="#hotel-hero">Inicio</a></li>
                                    <li><a href="#about-home">Conócenos</a></li>
                                    <li><a href="#amenities-cards">Instalaciones</a></li>
                                    <li><a href="#amenities">Servicios</a></li>
                                </ul>
                            </div>

                            <div className="col-lg-4 col-md-3 footer-links">
                                <ul>
                                    <li><a href="#contact">Contacto</a></li>
                                    <li><a href="/login">Acceso a clientes</a></li>
                                    <li><a href="/terminos">Términos y condiciones</a></li>
                                    <li><a href="/privacidad">Aviso de privacidad</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="copyright text-center">
                    <p><span>Desarrollado por </span><strong className="px-1 sitename"><a className="solgeek" href="https://solgeek.com/" target="_blank" rel="noreferrer">Solgeek</a></strong></p>
                </div>
            </footer>

            <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>

            <div id="preloader"></div>
        </Fragment>
    )
}

export default Footer;